<template>
    <div id="chongbi" class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('chongbi.title')}}</div>
            <img class="link" src="@/assets/jilu.png" @click="record" alt="">
        </div>
        <div class="cont-box">
            <router-link class="select-box" to="/selectCbBz" tag="ul">
                <li class="t1">{{currency}}</li>
                <li class="t2">{{this.$t('chongbi.xzbz')}}</li>
                <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <div class="tips">{{this.$t('chongbi.lianmc')}}</div>
            <ul class="tab-box" v-show="currency == 'USDT' || currency == 'USDC'">
                <li class="tab" :class="{active: tabIdx == index}" v-for="(item,index) in addressList" :key="index" @click="change(item.value,item.address,index)">{{item.value}}</li>
            </ul>
            <div id="qriously" class="center ewm-img"><qriously :value="address" :size="125"/></div>
            <div class="center"><a id="downLoad" class="btn-save" download="QR.png" :href="downLoadUrl">{{this.$t('chongbi.bcewm')}}</a></div>
            <div class="tips">
                <div>{{this.$t('chongbi.cbdz')}}</div>
            </div>
            <div class="input-ads">
                <div>{{address}}</div>

                <div class="click-proxy" @click="copy($event)">
                    <img class="icon" src="@/assets/copy3.png" style="pointer-events: none;"  alt="">
                </div>
            </div>
            <div class="tips">{{this.$t('chongbi.sl')}}</div>
            <div><input class="input" type="number" name="number" v-model="number" min="0" @keyup="keyMoney()" :placeholder="$t('chongbi.qsrsl')" autocomplete="off"></div>

            <div class="tips">{{this.$t('chongbi.hxz')}}</div>
            <div><input class="input" type="text" name="certificate" v-model="certificate" :placeholder="$t('chongbi.qsrhxz')" autocomplete="off"></div>
            <div class="tips">{{this.$t('chongbi.pztp')}}</div>
            <div v-if="certificate_url"><img class="upload" :src="certificate_url" alt="" @click="upload"></div>
            <div v-else><img class="upload" src="@/assets/btn-upload.png" alt="" @click="upload"></div>
            <div v-if="lang == 'zh'" class="tips-text">
              重要风险提示<br><br>
1. 选择错误的网络是导致资产丢失的主要原因。通过非 ERC20 网络（例如 BSC、TRON）发送 ERC20 代币几乎无法恢复资产。<br><br>

2. 区块链交易不可逆。如果您输入了错误的地址，而该地址确实存在，资产将被永久冻结。<br><br>

3. Gas 费用不足可能会导致交易延迟或失败。在网络拥堵期间，建议适当提高 Gas 费用以加快交易确认速度。<br><br>

4. 提现至交易所时，如果遗漏或错误填写 Memo/Tag，可能会导致资金无法及时到账。如果发生这种情况，请立即联系收款交易所的客服并提供交易哈希值以协助处理，但无法保证资金能够恢复。<br><br>

最佳安全实践<br><br>
1. 大额转账前测试：首次向新地址发送或进行大额转账之前，建议先发送一笔小额测试交易。确认成功后，方可继续支付全额款项。<br><br>

2. 保护私钥和助记词：您的私钥和助记词是控制您资产的唯一凭证。请将其安全地离线存储，切勿透露给任何人，包括官方客服。<br><br>

3. 使用硬件钱包：对于存储大量资产，强烈建议使用硬件钱包（冷钱包）进行离线存储，这是最安全的方法之一。<br><br>

4. 保持警惕：谨防钓鱼网站和虚假客服。请务必通过官方渠道访问我们的钱包服务，切勿点击来源不明的链接。<br><br>

如果遇到问题该怎么办？<br><br>
1. 交易延迟/丢失：首先，请使用交易哈希 (TxHash) 在 Etherscan 等区块链浏览器上检查交易状态。<br><br>

2. 如果未找到：交易可能尚未广播。请联系发送平台的客服。<br><br>

3. 如果待处理：网络可能拥堵。请耐心等待。<br><br>

4. 如果成功/已确认但未收到：请联系我们的支持团队并提供交易哈希值。<br><br>

5. 输入的提现地址错误：请立即联系我们的客服。但请注意，由于区块链交易不可逆的特性，成功恢复的可能性极低。确认前请务必仔细检查。<br><br>

6.疑似网络钓鱼或欺诈：请立即停止操作并通过官方渠道联系我们进行核实。<br><br>
            </div>
            <div v-else-if="lang == 'tw'" class="tips-text">
              重要風險提示<br><br>
1. 選擇錯誤的網路是導致資產遺失的主要原因。透過非 ERC20 網路（例如 BSC、TRON）發送 ERC20 代幣幾乎無法恢復資產。<br><br>

2. 區塊鏈交易不可逆。如果您輸入了錯誤的位址，而該位址確實存在，資產將永久凍結。<br><br>

3. Gas 費用不足可能導致交易延遲或失敗。在網路擁擠期間，建議適當提高 Gas 費用以加快交易確認速度。<br><br>

4. 提現至交易所時，如果遺漏或錯誤填寫 Memo/Tag，可能會導致資金無法及時到達。如果發生這種情況，請立即聯絡收款交易所的客服並提供交易哈希值以協助處理，但無法保證資金能夠恢復。<br><br>

最佳安全實踐<br><br>
1. 大額轉帳前測試：首次向新地址發送或進行大額轉帳前，建議先發送小額測試交易。確認成功後，方可繼續支付全額款項。<br><br>

2. 保護私鑰和助記詞：您的私鑰和助記詞是控制您資產的唯一憑證。請將其安全地離線存儲，切勿透露給任何人，包括官方客服。<br><br>

3. 使用硬體錢包：對於儲存大量資產，強烈建議使用硬體錢包（冷錢包）進行離線存儲，這是最安全的方法之一。<br><br>

4. 保持警覺：小心釣魚網站和假客服。請務必透過官方管道造訪我們的錢包服務，切勿點擊來源不明的連結。<br><br>

如果遇到問題該怎麼辦？<br><br>
1. 交易延遲/遺失：首先，請使用交易哈希 (TxHash) 在 Etherscan 等區塊鏈瀏覽器上檢查交易狀態。<br><br>

2. 如果找不到：交易可能尚未廣播。請聯絡發送平台的客服。<br><br>

3. 如果待處理：網路可能壅塞。請耐心等待。<br><br>

4. 如果成功/已確認但未收到：請聯絡我們的支援團隊並提供交易雜湊值。<br><br>

5. 輸入的提現地址錯誤：請立即聯絡我們的客服。但請注意，由於區塊鏈交易不可逆的特性，成功恢復的可能性極低。確認前請務必仔細檢查。<br><br>

6.疑似網路釣魚或詐欺：請立即停止操作並透過官方管道聯絡我們進行核實。<br><br>
            </div>
            <div v-else-if="lang == 'en'" class="tips-text">
              Important Risk Warnings<br><br>
1.Selecting the wrong network is the leading cause of asset loss. Sending ERC20 tokens via a non-ERC20 network (like BSC, TRON) makes it almost impossible to recover the assets.<br><br>

2.Blockchain transactions are irreversible. If you enter an incorrect address and that address actually exists, the assets will be permanently frozen there.<br><br>

3.Insufficient Gas fees may cause transaction delays or failures. During network congestion, it is recommended to appropriately increase the Gas fee to speed up transaction confirmation.<br><br>

4.Omitting or incorrectly filling the Memo/Tag when withdrawing to an exchange may prevent funds from being credited promptly. If this happens, immediately contact the recipient exchange's customer support and provide the TxHash to assist processing, but recovery is not guaranteed.<br><br>

Best Security Practices<br><br>
1.Test Before Large Transfers: Before sending to a new address for the first time, or for large transfers, it is advised to send a small test transaction first. Proceed with the full amount only after confirming success.<br><br>

2.Safeguard Private Keys and Seed Phrases: Your private keys and seed phrases are the only credentials controlling your assets. Store them securely offline and never disclose them to anyone, including official customer support.<br><br>

3.Use a Hardware Wallet: For storing large amounts of assets, it is highly recommended to use a hardware wallet (cold wallet) for offline storage, which is one of the most secure methods.<br><br>

4.Stay Vigilant: Beware of phishing sites and fake customer support. Always access our wallet services through official channels and do not click on links from unknown sources.<br><br>

What to Do If You Encounter Problems?<br><br>
1.Transaction Delayed/Lost: First, check the transaction status on a blockchain explorer like Etherscan using the Transaction Hash (TxHash).<br><br>

2.If not found: The transaction may not have been broadcast. Contact the sending platform's support.<br><br>

3.If Pending: The network might be congested. Please wait patiently.<br><br>

4.If Success/Confirmed but not received: Contact our support team and provide the TxHash.<br><br>

5.Incorrect Withdrawal Address Entered: Contact our customer support immediately. However, please note that the irreversible nature of blockchain transactions means the possibility of successful recovery is extremely low. Always double-check before confirming.<br><br>

6.Suspected Phishing or Fraud: Stop the operation immediately and contact us through official channels for verification.<br><br>
            </div>
            <div v-else-if="lang == 'jp'" class="tips-text">
              重要なリスクに関する警告<br><br>
1. 資産損失の主な原因は、誤ったネットワークの選択です。ERC20トークンをERC20以外のネットワーク（BSCやTRONなど）経由で送信すると、資産の回復は事実上不可能になります。<br><br>

2. ブロックチェーン取引は不可逆です。実在するアドレスを誤って入力した場合、資産は永久に凍結されます。<br><br>

3. ガス料金が不足すると、取引の遅延や失敗につながる可能性があります。ネットワークが混雑している時間帯は、ガス料金を引き上げ、取引の承認を迅速化することをお勧めします。<br><br>

4. 取引所への出金時に、メモ/タグ欄への記入漏れや誤入力があると、資金の入金が遅れる可能性があります。このような場合は、直ちに受取側の取引所のカスタマーサービスに連絡し、トランザクションハッシュをご提供ください。ただし、資金が確実に回復される保証はありません。<br><br>

セキュリティに関するベストプラクティス<br><br>
1. 多額の送金を行う前にテストを行う：新しいアドレスへの送金、または初めて多額の送金を行う前に、少額のテストトランザクションを送信することをお勧めします。この取引が成功したことが確認できたら、全額お支払いください。<br><br>

2. 秘密鍵とニーモニックフレーズを保護してください：秘密鍵とニーモニックフレーズは、お客様の資産を管理していることを示す唯一の証拠です。これらはオフラインで安全に保管し、公式カスタマーサービスを含む誰にも開示しないでください。<br><br>

3. ハードウェアウォレットを使用してください：多額の資産を保管する場合は、オフライン保管用のハードウェアウォレット（コールドウォレット）の使用を強くお勧めします。これは最も安全な方法の一つです。<br><br>

4. 警戒してください：フィッシングサイトや偽のカスタマーサービスにご注意ください。当社のウォレットサービスには必ず公式チャネルからアクセスし、身元不明のソースからのリンクは絶対にクリックしないでください。<br><br>

問題が発生した場合はどうすればよいですか？<br><br>

1. トランザクションの遅延/損失：まず、Etherscanなどのブロックチェーンエクスプローラーでトランザクションハッシュ（TxHash）を使用してトランザクションのステータスを確認してください。<br><br>

2. 見つからない場合：トランザクションがまだブロードキャストされていない可能性があります。送信元プラットフォームのカスタマーサービスにお問い合わせください。<br><br>

3. 保留中の場合：ネットワークが混雑している可能性があります。しばらくお待ちください。<br><br>

4. 成功／確認済みにもかかわらず入金されていない場合：サポートチームにご連絡の上、トランザクションハッシュをご提供ください。<br><br>

5. 入力された出金アドレスが間違っている場合：直ちにカスタマーサービスまでご連絡ください。ただし、ブロックチェーン取引は不可逆的な性質上、出金が成功する可能性は極めて低いことをご了承ください。確定前にアカウントをよくご確認ください。<br><br>

6. フィッシングまたは詐欺の疑いがある場合：直ちに操作を中止し、正式なチャネルを通じて確認のためにご連絡ください。<br><br>
            </div>
            <div v-else-if="lang == 'kr'" class="tips-text">
              중요 위험 경고<br><br>
1. 잘못된 네트워크 선택은 자산 손실의 주요 원인입니다. ERC20이 아닌 네트워크(예: BSC 또는 TRON)를 통해 ERC20 토큰을 전송하면 자산 회수가 사실상 불가능합니다.<br><br>

2. 블록체인 거래는 되돌릴 수 없습니다. 실제로 존재하는 잘못된 주소를 입력하면 자산이 영구적으로 동결됩니다.<br><br>

3. 가스 수수료가 부족하면 거래 지연 또는 실패가 발생할 수 있습니다. 네트워크 혼잡 기간에는 거래 확인 속도를 높이기 위해 가스 수수료를 높이는 것이 좋습니다.<br><br>

4. 거래소로 출금할 때 메모/태그 필드를 누락하거나 잘못 입력하면 자금이 지연될 수 있습니다. 이 경우 즉시 수취 거래소 고객센터에 연락하여 거래 해시를 제공하여 도움을 받으십시오. 하지만 자금 회수가 보장되지는 않습니다.<br><br>

보안 모범 사례<br><br>
1. 고액 이체 전 테스트: 새 주소로 전송하거나 처음으로 고액 이체를 하기 전에 소액 테스트 거래를 전송하는 것이 좋습니다. 이 거래가 성공적으로 확인되면 전체 결제를 진행하세요.<br><br>

2. 개인 키와 니모닉 문구를 보호하세요. 개인 키와 니모닉 문구는 자산 관리의 유일한 증거입니다. 오프라인에 안전하게 보관하고 공식 고객 서비스를 포함한 누구에게도 공개하지 마세요.<br><br>

3. 하드웨어 지갑 사용: 대량의 자산을 보관하는 경우, 오프라인 저장을 위한 하드웨어 지갑(콜드 지갑)을 사용하는 것이 매우 권장되며 가장 안전한 방법 중 하나입니다.<br><br>

4. 경계하세요. 피싱 웹사이트와 가짜 고객 서비스에 주의하세요. 항상 공식 채널을 통해 지갑 서비스에 접속하고, 출처가 확인되지 않은 링크는 절대 클릭하지 마세요.<br><br>

문제가 발생하면 어떻게 해야 하나요?<br><br>

1. 거래 지연/손실: 먼저 Etherscan과 같은 블록체인 탐색기에서 거래 해시(TxHash)를 사용하여 거래 상태를 확인하세요.<br><br>

2. 찾을 수 없는 경우: 거래가 아직 브로드캐스트되지 않았을 수 있습니다. 송금 플랫폼의 고객 서비스에 문의하세요.<br><br>

3. 보류 중: 네트워크가 혼잡할 수 있습니다. 잠시 기다려 주세요.<br><br>

4. 성공/확인되었지만 수신되지 않은 경우: 고객 지원팀에 문의하여 거래 해시를 제공해 주세요.<br><br>

5. 입력하신 출금 주소가 올바르지 않은 경우: 즉시 고객 서비스로 문의해 주세요. 하지만 블록체인 거래는 되돌릴 수 없기 때문에 복구 가능성은 매우 낮습니다. 확인 전에 계정을 신중하게 검토해 주세요.<br><br>

6. 피싱 또는 사기 의심: 즉시 운영을 중단하고 공식 채널을 통해 문의하여 확인해 주세요.<br><br>
            </div>
            <div v-else-if="lang == 'th'" class="tips-text">
              คำเตือนความเสี่ยงที่สำคัญ<br><br>
1. การเลือกเครือข่ายที่ไม่ถูกต้องเป็นสาเหตุหลักของการสูญเสียสินทรัพย์ การส่งโทเค็น ERC20 ผ่านเครือข่ายที่ไม่ใช่ ERC20 (เช่น BSC หรือ TRON) ทำให้การกู้คืนสินทรัพย์แทบจะเป็นไปไม่ได้<br><br>

2. ธุรกรรมบล็อกเชนไม่สามารถย้อนกลับได้ หากคุณป้อนที่อยู่ที่ไม่ถูกต้องซึ่งมีอยู่จริง สินทรัพย์ของคุณจะถูกระงับอย่างถาวร<br><br>

3. ค่าธรรมเนียมแก๊สที่ไม่เพียงพออาจทำให้ธุรกรรมล่าช้าหรือล้มเหลว ในช่วงที่มีการใช้งานเครือข่ายหนาแน่น ขอแนะนำให้เพิ่มค่าธรรมเนียมแก๊สเพื่อเร่งการยืนยันธุรกรรม<br><br>

4. เมื่อถอนเงินไปยังศูนย์แลกเปลี่ยน การละเว้นหรือกรอกข้อมูลในช่อง Memo/Tag ไม่ถูกต้องอาจทำให้เงินล่าช้า หากเกิดเหตุการณ์นี้ โปรดติดต่อฝ่ายบริการลูกค้าของศูนย์แลกเปลี่ยนผู้รับทันทีและแจ้งแฮชธุรกรรมเพื่อขอความช่วยเหลือ อย่างไรก็ตาม ไม่มีการรับประกันว่าเงินของคุณจะได้รับการกู้คืน<br><br>

แนวปฏิบัติที่ดีที่สุดด้านความปลอดภัย<br><br>
1. ทดสอบก่อนทำการโอนเงินจำนวนมาก: ก่อนโอนเงินไปยังที่อยู่ใหม่หรือทำการโอนเงินจำนวนมากเป็นครั้งแรก ขอแนะนำให้ทำธุรกรรมทดสอบจำนวนเล็กน้อย เมื่อได้รับการยืนยันว่าธุรกรรมนี้สำเร็จ ให้ดำเนินการชำระเงินเต็มจำนวน<br><br>

2. ปกป้องคีย์ส่วนตัวและวลีช่วยจำของคุณ: คีย์ส่วนตัวและวลีช่วยจำของคุณเป็นหลักฐานเดียวที่ยืนยันการควบคุมทรัพย์สินของคุณ จัดเก็บไว้อย่างปลอดภัยแบบออฟไลน์ และอย่าเปิดเผยให้ใครทราบ รวมถึงฝ่ายบริการลูกค้าอย่างเป็นทางการ<br><br>

3. ใช้กระเป๋าเงินฮาร์ดแวร์: สำหรับการจัดเก็บทรัพย์สินจำนวนมาก ขอแนะนำให้ใช้กระเป๋าเงินฮาร์ดแวร์ (กระเป๋าเงินเย็น) สำหรับการจัดเก็บแบบออฟไลน์ ซึ่งเป็นหนึ่งในวิธีที่ปลอดภัยที่สุด<br><br>

4. ระมัดระวัง: ระวังเว็บไซต์ฟิชชิ่งและฝ่ายบริการลูกค้าปลอม เข้าถึงบริการกระเป๋าเงินของเราผ่านช่องทางอย่างเป็นทางการเสมอ และอย่าคลิกลิงก์จากแหล่งที่มาที่ไม่ระบุ<br><br>

ฉันควรทำอย่างไรหากพบปัญหา<br><br>

1. ความล่าช้า/การสูญเสียธุรกรรม: ขั้นแรก ให้ตรวจสอบสถานะธุรกรรมบนเครื่องมือสำรวจบล็อกเชน เช่น Etherscan โดยใช้แฮชธุรกรรม (TxHash)<br><br>

2. หากไม่พบ: ธุรกรรมอาจยังไม่ได้รับการเผยแพร่ โปรดติดต่อฝ่ายบริการลูกค้าของแพลตฟอร์มที่ส่ง<br><br>

3. หากอยู่ระหว่างดำเนินการ: เครือข่ายอาจมีการใช้งานหนาแน่น โปรดรอสักครู่<br><br>

4. หากสำเร็จ/ยืนยันแล้ว แต่ยังไม่ได้รับ: โปรดติดต่อทีมสนับสนุนของเราและระบุแฮชธุรกรรม<br><br>

5. ที่อยู่ถอนเงินที่ป้อนไม่ถูกต้อง: โปรดติดต่อฝ่ายบริการลูกค้าของเราทันที อย่างไรก็ตาม โปรดทราบว่าเนื่องจากธุรกรรมบล็อกเชนไม่สามารถย้อนกลับได้ โอกาสในการกู้คืนจึงต่ำมาก โปรดตรวจสอบบัญชีของคุณอย่างละเอียดก่อนยืนยัน<br><br>

6. สงสัยว่าเป็นฟิชชิ่งหรือการฉ้อโกง: โปรดหยุดดำเนินการทันทีและติดต่อเราผ่านช่องทา<br><br>
            </div>
            <div v-else-if="lang == 'vn'" class="tips-text">
              Cảnh báo Rủi ro Quan trọng<br><br>
1. Chọn sai mạng là nguyên nhân chính gây mất tài sản. Việc gửi token ERC20 qua các mạng không phải ERC20 (như BSC hoặc TRON) khiến việc khôi phục tài sản gần như không thể.<br><br>

2. Giao dịch blockchain là không thể đảo ngược. Nếu bạn nhập sai địa chỉ thực tế, tài sản của bạn sẽ bị đóng băng vĩnh viễn.<br><br>

3. Phí gas không đủ có thể gây ra sự chậm trễ hoặc thất bại trong giao dịch. Trong thời gian mạng bị tắc nghẽn, nên tăng phí gas để tăng tốc độ xác nhận giao dịch.<br><br>

4. Khi rút tiền về sàn giao dịch, việc bỏ sót hoặc nhập sai trường Ghi nhớ/Thẻ có thể dẫn đến việc tiền bị chậm trễ. Nếu điều này xảy ra, vui lòng liên hệ ngay với bộ phận chăm sóc khách hàng của sàn giao dịch nhận tiền và cung cấp mã băm giao dịch để được hỗ trợ. Tuy nhiên, không có gì đảm bảo rằng tiền của bạn sẽ được khôi phục.<br><br>

Các Biện pháp Bảo mật Tốt nhất<br><br>
1. Kiểm tra trước khi thực hiện giao dịch chuyển tiền lớn: Trước khi gửi đến địa chỉ mới hoặc thực hiện giao dịch chuyển tiền lớn lần đầu tiên, bạn nên gửi một giao dịch thử nghiệm nhỏ. Sau khi giao dịch này được xác nhận thành công, hãy tiến hành thanh toán toàn bộ.<br><br>

2. Bảo vệ khóa riêng tư và cụm từ ghi nhớ của bạn: Khóa riêng tư và cụm từ ghi nhớ là bằng chứng duy nhất về quyền kiểm soát tài sản của bạn. Hãy lưu trữ chúng an toàn ngoại tuyến và không bao giờ tiết lộ cho bất kỳ ai, kể cả bộ phận chăm sóc khách hàng chính thức.<br><br>

3. Sử dụng ví phần cứng: Để lưu trữ số lượng lớn tài sản, việc sử dụng ví phần cứng (ví lạnh) để lưu trữ ngoại tuyến được khuyến nghị cao và là một trong những phương pháp an toàn nhất.<br><br>

4. Cảnh giác: Cẩn thận với các trang web lừa đảo và dịch vụ chăm sóc khách hàng giả mạo. Luôn truy cập dịch vụ ví của chúng tôi thông qua các kênh chính thức và tuyệt đối không nhấp vào các liên kết từ các nguồn không xác định.<br><br>

Tôi nên làm gì nếu gặp sự cố?<br><br>

1. Trì hoãn/mất mát giao dịch: Trước tiên, hãy kiểm tra trạng thái giao dịch trên trình duyệt blockchain như Etherscan bằng hàm băm giao dịch (TxHash).<br><br>

2. Nếu không tìm thấy: Giao dịch có thể chưa được phát sóng. Vui lòng liên hệ với bộ phận chăm sóc khách hàng của nền tảng gửi.<br><br>

3. Nếu đang chờ xử lý: Mạng có thể bị tắc nghẽn. Vui lòng kiên nhẫn chờ đợi.<br><br>

4. Nếu giao dịch thành công/đã xác nhận nhưng chưa nhận được: Vui lòng liên hệ với bộ phận hỗ trợ của chúng tôi và cung cấp mã băm giao dịch.<br><br>

5. Địa chỉ rút tiền đã nhập không chính xác: Vui lòng liên hệ ngay với bộ phận chăm sóc khách hàng của chúng tôi. Tuy nhiên, xin lưu ý rằng do tính chất không thể đảo ngược của các giao dịch blockchain, khả năng khôi phục thành công là cực kỳ thấp. Vui lòng kiểm tra kỹ tài khoản của bạn trước khi xác nhận.<br><br>

6. Nghi ngờ lừa đảo hoặc gian lận: Vui lòng ngừng giao dịch ngay lập tức và liên hệ với chúng tôi qua các kênh chính thức để xác minh.<br><br>
            </div>
            <div v-else-if="lang == 'es'" class="tips-text">
              Advertencias importantes sobre riesgos<br><br>
1. Seleccionar la red incorrecta es la principal causa de pérdida de activos. Enviar tokens ERC20 a través de redes que no son ERC20 (como BSC o TRON) hace que la recuperación de activos sea prácticamente imposible.<br><br>

2. Las transacciones en blockchain son irreversibles. Si ingresa una dirección incorrecta que realmente existe, sus activos se congelarán permanentemente.<br><br>

3. Las comisiones de gas insuficientes pueden causar retrasos o fallos en las transacciones. Durante periodos de congestión de la red, se recomienda aumentar las comisiones de gas para acelerar las confirmaciones de las transacciones.<br><br>

4. Al retirar fondos a una plataforma de intercambio, omitir o ingresar incorrectamente el campo Memo/Etiqueta puede resultar en retrasos en la recepción de los fondos. Si esto ocurre, comuníquese con el servicio de atención al cliente de la plataforma de intercambio receptora inmediatamente y proporcione el hash de la transacción para obtener ayuda. Sin embargo, no hay garantía de que sus fondos se recuperen.<br><br>

Mejores prácticas de seguridad<br><br>
1. Pruebe antes de realizar una transferencia grande: Antes de enviar a una nueva dirección o realizar una transferencia grande por primera vez, se recomienda realizar una pequeña transacción de prueba. Una vez confirmada la transacción, proceda con el pago completo.<br><br>

2. Proteja sus claves privadas y frases mnemotécnicas: Sus claves privadas y frases mnemotécnicas son la única prueba de control sobre sus activos. Guárdelas de forma segura fuera de línea y nunca las revele a nadie, ni siquiera al servicio de atención al cliente oficial.<br><br>

3. Use una billetera física: Para almacenar grandes cantidades de activos, se recomienda encarecidamente usar una billetera física (billetera fría) para almacenamiento fuera de línea y es uno de los métodos más seguros.<br><br>

4. Manténgase alerta: Tenga cuidado con los sitios web de phishing y los servicios de atención al cliente falsos. Acceda siempre a nuestros servicios de billetera a través de canales oficiales y nunca haga clic en enlaces de fuentes no identificadas.<br><br>

¿Qué debo hacer si tengo problemas?<br><br>

1. Retrasos/pérdidas de transacciones: Primero, verifique el estado de la transacción en un explorador de blockchain como Etherscan utilizando el hash de la transacción (TxHash).<br><br>

2. Si no se encuentra: Es posible que la transacción aún no se haya transmitido. Por favor, contacte con el servicio de atención al cliente de la plataforma de envío.<br><br>

3. Si está pendiente: La red podría estar congestionada. Espere pacientemente.<br><br>

4. Si la transacción es correcta o no se ha recibido: Contacte con nuestro equipo de soporte y proporcione el hash de la transacción.<br><br>

5. La dirección de retiro ingresada es incorrecta: Contacte con nuestro servicio de atención al cliente de inmediato. Sin embargo, tenga en cuenta que, debido a la naturaleza irreversible de las transacciones en blockchain, la probabilidad de recuperación exitosa es extremadamente baja. Revise cuidadosamente su cuenta antes de confirmar.<br><br>

6. Sospecha de phishing o fraude: Cese las operaciones de inmediato y contáctenos a través de los canales oficiales para su verificación.<br><br>
            </div>
        </div>
        <div class="btn-box">
            <div class="btn" @click="sure">{{this.$t('chongbi.sure')}}</div>
        </div>
        <loading v-show="isLoad"></loading>
        <input class="___input" type="file" ref="foreheadCir" mutiple="mutiple" accept="image/*" style="display: none;">
    </div>
</template>
<script>
import VueQriously from 'vue-qriously'
import loading from '@/components/loading.vue'
import lrz from "lrz";
export default {
    name: 'chongbi',
    data () {
        return {
            uid: '',
            token: '',
            lang: 'en',
            isLoad: false,
            tabIdx: 0,
            currency: 'USDC',
            addressList: [],
            address: '',
            chain: '',
            number: '',
            type: '',
            certificate: '',
            certificate_url: '',
            tag: '',
            downLoadUrl: '',
            count: 1
        }
    },
    created(){
      this.lang = localStorage.getItem('user_lang');
      this.token = localStorage.getItem('token');
      this.type = this.$route.query.type || 1;
      this.currency = localStorage.getItem('cbBzName') || 'USDC'
    },
    mounted(){
      this.getChainList()
    },
    methods: {
      goBack(){
           this.$router.push('/index')
       },
       record(){
           this.$router.push('/cbjl?idx=0')
       },
       change(chain,ads,idx){
           this.tabIdx = idx;
           this.chain = chain;
           this.address = ads;
       },
       select(){
           this.$router.push({ path: '/selectCurrency', query: { type: 1,url: 'deposit' } })
       },
       getChainList(){
           let params = {
               currency: this.currency
           }
           this.$ajax.get('/web/getChainList',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.length > 0){
                    this.addressList = resData;
                    this.address = resData[0].address;
                    this.chain = resData[0].value;
                    var imgData = $("canvas")[0].toDataURL('png');
                    this.downLoadUrl = imgData;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       sure(){
           var params = {
                'number': this.number,
                'address': this.address,
                'currency': this.currency,
                'type': this.type,
                'certificate_url': this.certificate_url,
                'certificate': this.certificate,
                'chain': this.chain,
                'tag': this.tag
            };
            if(params.number == '' || params.number == null || params.number <= 0){
                this.$toast.center(this.$t('chongbi.qsrsl'));
                return false;
            }
            if(params.certificate_url == '' || params.certificate_url == null){
                this.$toast.center(this.$t('tipsNew.qscpztp'));
                return false;
            }
            if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
            this.$ajax.post('/web/assetRecharge',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    this.$toast.center(this.$t('status.statusText')[2]);
                    setTimeout(() => {
                      this.count = 1;
                      this.$router.push('/cbjl?idx=0')
                    }, 1000)
                }else{
                    this.count = 1;
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
      upload(){
          var that = this;
          this.uploadimg(function (res) {
              that.certificate_url = res.url
          })
      },
      uploadimg(callback){
			    let that = this;
			    that.ele_input(function(res) {
            if (res.length > 0) {
              var formdata = new FormData();
              for (var i = 0, len = res.length; i < len; i++) {
                lrz(res[0]).then(function (rst) {
                  var formdata = new FormData();
                  let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                  formdata.append('file', file);
                  formdata.append('token', that.token);
                  formdata.append('app', 'h5');
                  that.isLoad = true;
                  $.ajax({
                    url: that.domain + "/web/uploadImg",
                    type: "POST",
                    data: formdata,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: function(data) {
                      if (typeof data == 'string') data = JSON.parse(data.data)
                      if (data && data.code == 0) {
                        that.isLoad = false;
                        that.certificate_url = data.data.url;
                      }else{
                        that.isLoad = false;
                        that.$toast.center(data.message);
                        return;
                      }
                    },error: function(data) {
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  });
                })
              }
            }
			  })
		  },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
        }
        inputs.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        inputs.click();
      },
      hideLoad(){
          this.isLoad = false;
      },
      copy(e){
          let address = this.address;
          this.$copyText(address, this.$t('chongbi.fzcg'));
          this.$toast.center(this.$t('chongbi.fzcg'));
      },
      keyMoney(){
          this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
              this.number = parseFloat(this.number);
          }
      },
    },
    components:{
		  loading
    },
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #666;
        font-size: .38rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .center{
        text-align: center;
    }
    .head{
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .link{
        position: absolute;
        right: .36rem;
        top: .24rem;
        width: .6rem;
        height: .6rem;
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: 1.2rem;
        bottom: 1.6rem;
        width: 100%;
        height: auto;
        padding: 0 .24rem .5rem;
        color: #000;
        font-size: .36rem;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .select-box{
        display: flex;
        align-items: center;
        padding: .5rem 0 .3rem;
        border-bottom: 1px solid #313a47;
    }
    .select-box .t1{
        flex: 1;
        color: #fff;
        font-size: .48rem;
    }
    .select-box .t2{
        padding-right: .24rem;
        color: #d2d2d2;
        font-size: .42rem;
    }
    .select-box .arrow{
        width: .18rem;
        height: .36rem;
    }
    .cont-box .tips{
        display: flex;
        justify-content: space-between;
        padding: .62rem 0 .2rem;
        color: #ababab;
        font-size: .42rem;
    }
    .cont-box .tips .copy{
        color: #4bb3e8;
    }
    .tab-box{
        display: flex;
        justify-content: flex-start;
        flex-flow: wrap;
        padding: 0 .1rem .2rem;
    }
    .tab-box .tab{
        position: relative;
        width: 30%;
        height: 1rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1rem;
        margin: 0 .2rem .1rem 0;
        border-radius: 4px;
        background: rgba(70, 89, 148,.2);
        text-align: center;
    }
    .tab-box .tab.active::after{
        position: absolute;
		right: 0;
		bottom: 0;
		content: '';
		width: .7rem;
		height: .78rem;
		background: url('./../assets/Trend_Selected.png') no-repeat right center;
		background-size: .5rem .56rem;
    }
    .ewm-text{
        padding: .46rem 0 .28rem;
        color: #bababa;
        font-size: .39rem;
    }
    .ewm-img{
        display: flex;
        justify-content: center;
    }
    .btn-save{
        display: inline-block;
        width: 4.2rem;
        height: 1.2rem;
        margin-top: .56rem;
        text-decoration: none;
        color: #fff;
        font-size: .42rem;
        line-height: 1.2rem;
        border-radius: .56rem;
        background: linear-gradient(267deg,rgba(44, 170, 222, 0.2), rgba(93, 205, 233, 0.2));
        text-align: center;
    }
    .input-ads{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #D2D2D2;
        padding: .22rem .25rem .18rem;
        font-size: .36rem;
        border-radius: 10px;
        background: rgba(4, 9, 37,.5);
        word-break: break-word;
        box-sizing: border-box;
        text-align: center;
    }
    .input-ads .icon{
        padding-left: .4rem;
        width: .56rem;
        height: .56rem;
    }
    .input{
        width: 100%;
        height: 1.2rem;
        padding: 0 .25rem;
        color: #fff;
        font-size: .42rem;
        border: 1px solid #515151;
        border-radius: 6px;
        background: transparent;
        box-sizing: border-box;
    }
    .upload{
        width: 3.2rem;
        height: 2.8rem;
        opacity: .8;
    }
    .btn-box{
        position: absolute;
        bottom: .28rem;
        width: 100%;
        padding: 0 .3rem;
        box-sizing: border-box;
    }
    .tips{
        padding: .5rem .24rem .4rem;
        color: #ababab;
        font-size: .42rem;
    }
    .tips-text{
        padding: .4rem 0 .2rem;
        color: #ababab;
        font-size: .42rem;
    }
    .btn{
        width: 100%;
        height: 1.2rem;
        color: #fff;
        font-size: .42rem;
        line-height: 1.2rem;
        background: linear-gradient(left,  rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .14rem;
        text-align: center;
    }
</style>
<style>
    #chongbi canvas{
        background: #fff!important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/deposit.vue